import {initSlider} from './initSlider';
import {Lightbox} from '../../classes/Lightbox';

export const initLightboxes = ( apartmentCard ) => {
	const lightboxContent = document.createElement( 'div' );

	lightboxContent.classList.add( 'apartment-slider', 'new-slider' );

	apartmentCard.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.classList.contains( 'lightbox' ) )
		{
			return;
		}

		lightboxContent.innerHTML = evt.target.classList.contains( 'zoom' ) ? apartmentCard.querySelector( 'div.apartment-slider' ).innerHTML : `<div class="wrapper"><ul class="slides  view" data-slider-role="slides">${JSON.parse( evt.target.dataset.view.replace( ',]', ']' ) ).map( ( src ) => `<li><img src="${src.file.replace( 'view', 'view/xl_both' )}" alt="${src.title}" title="${src.title}" /><p>${src.title}, <time datetime="${src.datetime}">${new Date( src.datetime ).getDate()}.${src.datetime.split( '-' )[1]}.${new Date( src.datetime ).getFullYear()}</time></p></li>` ).join( '' )}</ul></div><ul class="buttons" data-slider-role="buttons"><li class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="38"><path fill="none" stroke-width="2" d="m3-1 12 19.997L3 39" /></svg></li><li class="next"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="38"><path fill="none" stroke-width="2" d="m3-1 12 19.997L3 39" /></svg></li></ul>`;
		Lightbox.open( lightboxContent, null, 'fullscreen-lightbox', 'apartment-lightbox' );

		const lightbox = document.querySelector( 'div.fullscreen-lightbox' );
		const slider = lightbox.querySelector( 'div.apartment-slider' );
		const mapCard = slider.querySelector( '#map-apartment-card' );

		if ( !evt.target.classList.contains( 'zoom' ) )
		{
			lightbox.classList.add( 'view' );
		}

		if ( mapCard )
		{
			mapCard.setAttribute( 'id', 'map-apartment-card-full' );
		}
		
		const mapContainer = lightbox.querySelector( '.map.yandex' );
		if ( mapContainer )
		{
			mapContainer.classList.remove( 'required' );
			mapContainer.classList.remove( 'loaded' );
			
			const ymaps = mapContainer.querySelector( 'ymaps' );
			if ( ymaps )
			{
				ymaps.remove();
			}
			
			mapContainer.setAttribute( 'id', `${mapContainer.getAttribute( 'id' )}-lightbox` );
			
			window.init_yandex_map();
		}
		
		initSlider( slider );
	} );
};
